import React from "react";
import { CardLayout } from "components/cardLayout";
import { Header } from "components/header";
import { CardSubItem } from "components/cardSubItem";
import { CardItem } from "components/cardItem";
import { amslogo, logo } from 'assets/images';
import { navigate } from "@reach/router";
import { MoveListCard } from "components/moveListCard";
import { IMove, MovePaymentStatusEnum, MoveStatusEnum } from "core/model/move";
import { IAmbassador } from "core/model/ambassador";
import { getMovesSummaryByMonth, getMoves } from "core/services/movesService";
import { IMoveSummary } from "core/model/ambassador";

const NO_MOVE_STATUS: MoveStatusEnum[] = []; 
const NO_PAYMENT_STATUS = [MovePaymentStatusEnum.CANCELLED]; 


export interface EstimateDetailsProps {
    
}

export interface EstimateDetailsState {
    
}

export default class EstimateDetails extends React.Component<EstimateDetailsProps, EstimateDetailsState> {
   
    
    constructor(props: EstimateDetailsProps) {
        super(props);
        this.state = {
            movesSummary: null,
            moves: null
        };
    }
    onLeftIconPress(){
        navigate('/');
    }

    openMoveDetail(move: any) {
        // navigate(`/moves/${move.moveID}`);
        alert("click me")
    }

    render() {
        return (
            <div className="thankyou-container">
                <Header
                    leftIcon={'home'}
                    leftText={'Home'}
                    rightIcon={"phone"}
                    rightText={"Call Us"}
                    onLeftIconPress={this.onLeftIconPress}
                />
                <div className="thankyou-title">
                    <h1>Estimate Details</h1>
                </div>
                
                {/* <MoveListCard
                    title="Recent Reviews Near You"
                    // paymentStatuses={NO_PAYMENT_STATUS}
                    // moveStatuses={NO_MOVE_STATUS}
                    // list={this.getMoves(NO_PAYMENT_STATUS, NO_MOVE_STATUS)}
                    onClick={(item: any) => this.openMoveDetail(item)}
                    cancelAmount={true}
                    cancelTotalAmount={true}
                    
                /> */}
                
            </div>
        )
    }
}